export default {
  meta: {
    title: $localize`:@@meta.contacts.title:Контакты → CSFAIL`,
    description: $localize`:@@meta.contacts.desc:Возникли вопросы, которые нужно задать напрямую? Свяжитесь с нами по электронной почте, проверьте нашу лицензию и бенефициара на этой странице`
  }
};